export const getCurrentLotIndex = (lot, ids) => ids.indexOf(lot.raw_lot_id);
